var config = require('./config.js')
module.exports = {
  debug: function (obj) {
    if (config.isDebug) {
      let date = new Date().toLocaleString('en-GB')
      if (typeof obj === 'object') {
        console.log('[' + date + ']' + JSON.stringify(obj))
      } else {
        console.log('[' + date + ']' + obj)
      }
    }
  },
  info: function (obj) {
    let date = new Date().toLocaleString('en-GB')
    if (typeof obj === 'object') {
      console.log('[' + date + ']' + JSON.stringify(obj))
    } else {
      console.log('[' + date + ']' + obj)
    }
  },
  error: function (obj) {
    let date = new Date().toLocaleString('en-GB')
    if (typeof obj === 'object') {
      console.log('[' + date + ']' + JSON.stringify(obj))
    } else {
      console.log('[' + date + ']' + obj)
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/utils/logger.js